import useInterval from '@use-it/interval'
import React, { useEffect, useState } from 'react'
import {
  ScrollView,
  Text,
  StyleSheet,
  View,
  ActivityIndicator
} from 'react-native'
import { useDispatch } from 'react-redux'
import entityActions, { runFinalImportNew } from '../store/entity/actions'
import MSFESButton from '../components/MSFESButton'
import spacing from '../styles/spacing'
import { isString } from 'lodash'
export const JobViewScreen = ({ route, navigation }) => {
  const dispatch = useDispatch()
  const { id } = route.params
  const [currentInfo, setCurrentInfo] = useState(null)

  useEffect(() => {
    setCurrentInfo(null)
  }, [id])

  let isRequestPending = false

  const [loading, setLoading] = useState(false)
  const runFinalImport = () => {
    setLoading(true)
    dispatch(runFinalImportNew(currentInfo.params.import_id)).then(
      (response) => {
        if (response.importId) {
          setCurrentInfo(null)
          navigation.navigate('JobView', {
            id: response.importId
          })
          setLoading(false)
        }
      }
    )
  }
  const fetchJobDetails = () => {
    if (!isRequestPending) {
      isRequestPending = true
      dispatch(entityActions.requestLongRunningJobUpdate(id))
        .then((details) => {
          setCurrentInfo(details)
        })
        .finally(() => {
          isRequestPending = false
        })
    }
  }

  useInterval(fetchJobDetails, 5000)
  useEffect(fetchJobDetails, [])
  return (
    <View style={{ padding: spacing.m2, flex: 1 }}>
      {!currentInfo && (
        <View style={{ flexDirection: 'row' }}>
          <ActivityIndicator />
          <Text style={{ paddingLeft: spacing.m2 }}>
            Waiting for ID to be available
          </Text>
        </View>
      )}
      {currentInfo && (
        <View style={{ flex: 1 }}>
          <ScrollView style={{ flex: 1 }}>
            <Text style={styles.smallHeader}>Successful Rows:</Text>
            <Text style={{ flexWrap: 'wrap', width: '100%' }}>
              {currentInfo.importedItems}
            </Text>
            <Text style={styles.smallHeader}>
              Ignored Fields (could not match field name):
            </Text>
            <Text style={{ flexWrap: 'wrap', width: '100%' }}>
              {(currentInfo.ignoredFields ?? []).join(', ')}
            </Text>
            {currentInfo.error && (
              <>
                <Text style={styles.smallHeader}>ERROR:</Text>
                <Text>{currentInfo.error}</Text>
              </>
            )}

            <Text style={styles.smallHeader}>Import ID:</Text>
            <Text>{currentInfo.params.import_id}</Text>
            <Text style={styles.smallHeader}>Was Test?:</Text>
            <Text>
              {currentInfo.testRun ? 'YES - No Records were imported' : 'NO'}
            </Text>
            <Text style={styles.smallHeader}>Imported Items:</Text>
            <Text>{currentInfo.importedItems}</Text>

            <Text style={styles.smallHeader}>Failed Rows:</Text>
            <View>
              {currentInfo.failedRows?.map((row, index) => {
                return (
                  <Text key={index}>
                    Row {row.index}: {row.exception}
                  </Text>
                )
              })}
            </View>
            <Text style={styles.smallHeader}>Batches Completed:</Text>
            <Text>{currentInfo.tasksCompleted}</Text>
            <Text style={styles.smallHeader}>Finished:</Text>
            <Text>{currentInfo.finished ? 'YES' : 'NO'}</Text>
            <Text style={{ fontSize: 12, display: 'none' }}>
              {isString(currentInfo)
                ? currentInfo
                : JSON.stringify(currentInfo)}
            </Text>
          </ScrollView>
          {currentInfo.testRun && (
            <MSFESButton
              onPress={runFinalImport}
              title="Run Final Import"
              disabled={!currentInfo?.finished}
              loading={loading}
            />
          )}
        </View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  smallHeader: {
    fontSize: 18,
    paddingVertical: 6,
    fontWeight: 'bold'
  }
})
